<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div class="container">
      <!-- Başlık -->
      <div class="row justify-center items-center mb-60 md:mb-40 sm:mb-20">
        <div>
          <div v-html="vars.titleHtml" class="tw-text-center"></div>
        </div>
      </div>

      <div class="relative">
        <!-- Masaüstü & Tablet Görünümü -->
        <div class="tw-hidden md:tw-block">
          <div v-for="(card, index) in cards" :key="index" class="tw-mb-8 tw-flex tw-flex-row tw-gap-6 tw-border-2">
            <!-- Sol taraf: resim -->
            <div class="tw-w-1/4">
              <library-image
                :src="card.photo"
                w-ratio="5"
                h-ratio="6"
                alt="image"
                image-class="tw-h-full tw-w-full tw-object-cover"
              />
            </div>
            <!-- Sağ taraf: içerik -->
            <div class="tw-flex tw-w-3/4 tw-flex-col tw-p-6">
              <div>
                <h3>{{ card.title }}</h3>
                <h6 class="tw-mt-3" style="color: #666666">
                  {{ card.duration }}
                </h6>

                <div class="tw-mt-8 tw-h-32 tw-overflow-y-auto tw-overflow-x-hidden">
                  <p class="tw-whitespace-normal">
                    {{ card.description }}
                  </p>
                </div>
              </div>
              <div class="tw-mt-6">
                <button
                  :class="`n-${card.button_type}`"
                  class="tw-bg-dark-1 tw-px-6 tw-py-3 tw-font-medium tw-uppercase tw-text-white"
                >
                  {{ card.button_label }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobil Görünüm -->
        <div class="tw-block md:tw-hidden">
          <div class="tw-grid tw-grid-cols-1 tw-gap-4">
            <div
              v-for="(card, index) in cards"
              :key="`mobile-${index}`"
              class="tw-mb-4 tw-flex tw-flex-col tw-gap-4 tw-border"
            >
              <!-- Resim -->
              <div class="tw-w-full">
                <library-image
                  :src="card.photo"
                  w-ratio="1"
                  h-ratio="1"
                  alt="image"
                  image-class="tw-h-full tw-w-full tw-object-cover"
                />
              </div>
              <!-- İçerik -->
              <div class="tw-flex tw-flex-col tw-p-4">
                <h3 class="tw-uppercase">{{ card.title }}</h3>
                <h6 class="tw-mt-1">{{ card.duration }}</h6>
                <div class="tw-mt-4 tw-h-32 tw-overflow-hidden">
                  <p class="tw-line-clamp-5">{{ card.description }}</p>
                </div>
                <div class="tw-mt-6">
                  <button
                    :class="`n-${card.button_type}`"
                    class="tw-bg-dark-1 tw-w-full tw-px-4 tw-py-2 tw-font-medium tw-uppercase tw-text-white"
                  >
                    {{ card.button_label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'Theme7OurValuations',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
